import React from "react";
import { wrapCollectionLayout, Link, LoadMoreButton } from "@quintype/components";
import "./one-col-story-list.module.css";
import { VerticalStory } from "../basic/vertical-story-card/vertical-story";
import PropTypes from "prop-types";
import { DfpAd } from "../../components/dfp-ad";
import { CollectionName } from "../basic/collection-name.js";

function OneColStoryListBase({ stories, associatedMetadata, config, collection, onLoadMore, noMoreStories }) {
  const { show_collection_title: collectionName = true, limitStories = 0 } = associatedMetadata;
  if (limitStories) stories = stories.slice(0, limitStories);
  return (
    <div styleName="component-wrapper" data-testid="one-col-story-list">
      {!collectionName ? null : <CollectionName name={collection.name} type="large" section={collection} />}
      <div styleName="one-col-story-list-wrapper">
        <div styleName="vertical-stories-wrapper" data-testid="vertical-stories-wrapper">
          {stories.map(story => {
            return (
              <Link href={`/${story.slug}`} key={story.id}>
                <VerticalStory story={story} config={config} />
              </Link>
            );
          })}
        </div>
        <div className="app-ad app-ad--vertical">
          <DfpAd adtype="Vertical-Ad" layoutName="FullscreenMediaList" collectionSlug={config["collection-slug"]} />
        </div>
      </div>
      {!noMoreStories && <LoadMoreButton className="load-more-button" onLoadMore={onLoadMore} text="Load More" />}
    </div>
  );
}
OneColStoryListBase.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object),
  config: PropTypes.object,
  collection: PropTypes.object,
  associatedMetadata: PropTypes.object,
  onLoadMore: PropTypes.func,
  noMoreStories: PropTypes.bool
};

export const OneColStoryList = wrapCollectionLayout(OneColStoryListBase);
